import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box } from "@material-ui/core"
import { PaginationDownSVG, PaginationUpSVG, ZoomInSVG, ZoomOutSVG } from "../icons"
import { Skeleton } from "@material-ui/lab"
import { useHistory } from "react-router-dom"
import ViewerPagination from "./ViewerPagination"
import ViewerDownloadFile from "./ViewerDownloadFile"
import ViewerHighlight from "./ViewerHighlight"
import AnnotationSVG from "../icons/AnnotationSVG"
import ToggleButton from "@material-ui/lab/ToggleButton"
import { searchHighlightFilter, updateAnnotationStatus } from "../../actions/highlightActions"
import ViewerDocumentNavigation from "./ViewerDocumentNavigation"
import NativeViewSwitch from "./NativeViewSwitch"

const useStyles = makeStyles((theme) => ({
	root: {
		...theme.typography.body1,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
		marginBottom: "20px",
		display: "flex",
		"& .MuiToggleButton-root.Mui-selected": {
			borderRadius: 0,
		},
		"& .MuiToggleButton-root.Mui-selected": {
			background: "rgba(52, 118, 228, 0.12)",
			borderRadius: 0,
		},
		"& .MuiToggleButton-root": {
			borderRight: `solid 1px ${theme.palette.grey.D400}`,
		},
		overflow: "auto",
	},
	highlight: { flex: 3, padding: "16px 23px", borderRight: `solid 1px ${theme.palette.grey.D400}` },
	pagination: {
		flex: 5,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: "16px 23px",
		borderRight: `solid 1px ${theme.palette.grey.D400}`,
		"& .MuiInputBase-input": {
			padding: "5px 10px",
			marginRight: "10px",
			border: `solid 1px ${theme.palette.grey.D400}`,
		},
	},
	download: { flex: 1, padding: "16px 23px", borderRight: `solid 1px ${theme.palette.grey.D400}` },
}))

const NativeHeader = (props) => {
	const classes = useStyles()
	const { Toolbar, annotationStatus } = props
	const dispatch = useDispatch()
	const theme = useTheme()
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	return (
		<Box className={classes.root}>
			<NativeViewSwitch />
			{<ViewerHighlight {...props} />}
			{<ViewerDocumentNavigation {...props} />}
			<Toolbar>
				{(props) => {
					const { CurrentPageInput, CurrentScale, GoToNextPage, GoToPreviousPage, NumberOfPages, ZoomIn, ZoomOut } = props
					return (
						<>
							<Box className={classes.pagination}>
								<ZoomOut>
									{(props) => (
										<Box
											disabled={props.isDisabled}
											onClick={props.onClick}
											style={{ display: "flex", cursor: "pointer", padding: "0px 10px" }}
										>
											<ZoomOutSVG />
										</Box>
									)}
								</ZoomOut>
								<CurrentScale>{(props) => <span>{`${Math.round(props.scale * 100)}%`}</span>}</CurrentScale>
								<ZoomIn>
									{(props) => (
										<Box
											disabled={props.isDisabled}
											onClick={props.onClick}
											style={{
												padding: "0px 10px",
												display: "flex",
												cursor: "pointer",
											}}
										>
											<ZoomInSVG />
										</Box>
									)}
								</ZoomIn>
							</Box>
							<Box className={classes.pagination}>
								<GoToPreviousPage>
									{(props) => (
										<Box
											disabled={props.isDisabled}
											onClick={props.onClick}
											style={{ display: "flex", cursor: "pointer" }}
										>
											<PaginationUpSVG />
										</Box>
									)}
								</GoToPreviousPage>
								<GoToNextPage>
									{(props) => (
										<Box
											disabled={props.isDisabled}
											onClick={props.onClick}
											style={{
												padding: "0px 10px",
												display: "flex",
												cursor: "pointer",
											}}
										>
											<PaginationDownSVG />
										</Box>
									)}
								</GoToNextPage>

								<Box style={{ display: "flex", alignItems: "center" }}>
									<CurrentPageInput />/<NumberOfPages />
								</Box>
							</Box>
						</>
					)
				}}
			</Toolbar>
			<ToggleButton
				value="annotation"
				selected={annotationStatus}
				onChange={() => {
					dispatch(updateAnnotationStatus(!annotationStatus))
				}}
			>
				<AnnotationSVG />
			</ToggleButton>
			<ViewerDownloadFile {...props} />
		</Box>
	)
}

export default NativeHeader
